module.exports = __webpack_public_path__ + "img/hr-assembling-machine-2-shadow.fd5a19b8.png";